export enum CommonRouteEnum {
  Root = '/',
  Home = '/home',

  // todo: вынести в task
  DesktopTasks = '/home/desktop/tasks',
  DesktopTaskList = '/home/desktop/tasks/list',
  DesktopTaskListMap = '/home/desktop/tasks/map',
}
